module.exports = __webpack_public_path__ + "static/media/fl3.0992b63f.jpg";